import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlignTypes } from '@monorepo-web/components-library';
import { auxFormatPercent, FormatTypes, groupAndSumByProperties, helperFormat, hexToRGBA, sumByProperties, } from '@monorepo-web/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
export function getColumnsDadosAgrupados(datas_dados_ativos_agrupados, preferenceCustomizacao) {
    var _a, _b, _c;
    const columnsDadosAgrupados = [
        {
            id: 'nome_ativo',
            label: 'Ativo',
            colorLegend: true,
            freeze: true,
            width: '300px',
            noBreak: true,
        },
        {
            id: 'sbr_ini',
            label: `Saldo Bruto ${(_a = datas_dados_ativos_agrupados === null || datas_dados_ativos_agrupados === void 0 ? void 0 : datas_dados_ativos_agrupados.data_ini) === null || _a === void 0 ? void 0 : _a.split('-').reverse().join('/')}`,
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'apl',
            label: 'Aplicações no período',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'res',
            label: 'Resgates no período',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'evento',
            label: 'Eventos',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'sbr_fim',
            label: `Saldo Bruto ${(_b = datas_dados_ativos_agrupados === null || datas_dados_ativos_agrupados === void 0 ? void 0 : datas_dados_ativos_agrupados.data_fim) === null || _b === void 0 ? void 0 : _b.split('-').reverse().join('/')}`,
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'rendimento',
            label: 'Rendimento Bruto',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'imposto_pago',
            label: 'Impostos Pagos',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'provisao_IR_IOF',
            label: 'Provisão IR+IOF',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'sli_fim',
            label: 'Saldo Líquido',
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        {
            id: 'percent_sli',
            label: (_c = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.PosCon_headerPercent) !== null && _c !== void 0 ? _c : '%',
            align: AlignTypes.right,
        },
    ];
    return columnsDadosAgrupados;
}
export function formatRowsDadosAgrupados(theme, dispatchPDF, onRowClickHandle, setNomeAtivoModal, dados_ativos_agrupados) {
    const rowsDadosAgrupados = [];
    const dadosAgrupados = dados_ativos_agrupados
        ? groupAndSumByProperties(dados_ativos_agrupados, 'classe', 'subclasse', [
            'sbr_ini',
            'apl',
            'res',
            'evento',
            'sbr_fim',
            'rendimento',
            'imposto_pago',
            'provisao_IR_IOF',
            'sli_fim',
            'percent_sli',
        ])
        : [];
    const totalAtivos = dados_ativos_agrupados
        ? sumByProperties(dados_ativos_agrupados, [
            'sbr_ini',
            'apl',
            'res',
            'evento',
            'sbr_fim',
            'rendimento',
            'imposto_pago',
            'provisao_IR_IOF',
            'sli_fim',
            'percent_sli',
        ])
        : [];
    dadosAgrupados === null || dadosAgrupados === void 0 ? void 0 : dadosAgrupados.forEach((classe, index) => {
        // linha classe
        if (classe.class)
            rowsDadosAgrupados.push({
                nome_ativo: classe.class,
                colorIndex: index,
                bgColor: theme.classColor,
                color: theme.backgroundColor,
                bold: true,
                sbr_ini: '',
                apl: '',
                res: '',
                evento: '',
                sbr_fim: '',
                rendimento: '',
                imposto_pago: '',
                provisao_IR_IOF: '',
                sli_fim: '',
                percent_sli: '',
                openModal: null,
            });
        classe.subclasses.forEach((subclasse) => {
            // linha subclasse
            if (subclasse.subclass)
                rowsDadosAgrupados.push({
                    nome_ativo: subclasse.subclass,
                    bgColor: '#E7E7E7',
                    color: theme.fontColor,
                    bold: true,
                    colorIndex: index,
                    sbr_ini: '',
                    apl: '',
                    res: '',
                    evento: '',
                    sbr_fim: '',
                    rendimento: '',
                    imposto_pago: '',
                    provisao_IR_IOF: '',
                    sli_fim: '',
                    percent_sli: '',
                    openModal: null,
                });
            subclasse.values.forEach((ativo) => {
                var _a, _b;
                // ativo
                rowsDadosAgrupados.push({
                    nome_ativo: ((_a = ativo.chave_para_modal) === null || _a === void 0 ? void 0 : _a.data_compra_AAAAmmDD) && !dispatchPDF ? (_jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faMagnifyingGlass, style: { marginRight: 4 } }), ativo.nome_ativo] })) : (ativo.nome_ativo),
                    sbr_ini: helperFormat(ativo.sbr_ini, FormatTypes.decimals, 2),
                    apl: helperFormat(ativo.apl, FormatTypes.decimals, 2),
                    res: helperFormat(ativo.res, FormatTypes.decimals, 2),
                    evento: helperFormat(ativo.evento, FormatTypes.decimals, 2),
                    sbr_fim: helperFormat(ativo.sbr_fim, FormatTypes.decimals, 2),
                    rendimento: helperFormat(ativo.rendimento, FormatTypes.decimals, 2),
                    imposto_pago: helperFormat(ativo.imposto_pago, FormatTypes.decimals, 2),
                    provisao_IR_IOF: helperFormat(ativo.provisao_IR_IOF, FormatTypes.decimals, 2),
                    sli_fim: helperFormat(ativo.sli_fim, FormatTypes.decimals, 2),
                    percent_sli: helperFormat(auxFormatPercent(ativo.percent_sli), FormatTypes.decimals, 2),
                    colorIndex: index,
                    openModal: ((_b = ativo.chave_para_modal) === null || _b === void 0 ? void 0 : _b.data_compra_AAAAmmDD)
                        ? () => {
                            onRowClickHandle(ativo.chave_para_modal);
                            setNomeAtivoModal(ativo.nome_ativo);
                        }
                        : null,
                    chave_para_modal: ativo.chave_para_modal,
                });
            });
            // total subclasse
            if (subclasse.subclass)
                rowsDadosAgrupados.push({
                    nome_ativo: `Total ${subclasse.subclass}`,
                    sbr_ini: helperFormat(subclasse.subtotal.sbr_ini, FormatTypes.decimals, 2),
                    apl: helperFormat(subclasse.subtotal.apl, FormatTypes.decimals, 2),
                    res: helperFormat(subclasse.subtotal.res, FormatTypes.decimals, 2),
                    evento: helperFormat(subclasse.subtotal.evento, FormatTypes.decimals, 2),
                    sbr_fim: helperFormat(subclasse.subtotal.sbr_fim, FormatTypes.decimals, 2),
                    rendimento: helperFormat(subclasse.subtotal.rendimento, FormatTypes.decimals, 2),
                    imposto_pago: helperFormat(subclasse.subtotal.imposto_pago, FormatTypes.decimals, 2),
                    provisao_IR_IOF: helperFormat(subclasse.subtotal.provisao_IR_IOF, FormatTypes.decimals, 2),
                    sli_fim: helperFormat(subclasse.subtotal.sli_fim, FormatTypes.decimals, 2),
                    percent_sli: helperFormat(auxFormatPercent(subclasse.subtotal.percent_sli), FormatTypes.decimals, 2),
                    colorIndex: index,
                    // bgColor: theme.chartLighterColors[index % theme.chartLighterColors.length],
                    bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLighter),
                    color: theme.fontColor,
                    bold: true,
                    openModal: null,
                });
        });
        // total classe
        if (classe.class)
            rowsDadosAgrupados.push({
                nome_ativo: `Total ${classe.class}`,
                sbr_ini: helperFormat(classe.subtotal.sbr_ini, FormatTypes.decimals, 2),
                apl: helperFormat(classe.subtotal.apl, FormatTypes.decimals, 2),
                res: helperFormat(classe.subtotal.res, FormatTypes.decimals, 2),
                evento: helperFormat(classe.subtotal.evento, FormatTypes.decimals, 2),
                sbr_fim: helperFormat(classe.subtotal.sbr_fim, FormatTypes.decimals, 2),
                rendimento: helperFormat(classe.subtotal.rendimento, FormatTypes.decimals, 2),
                imposto_pago: helperFormat(classe.subtotal.imposto_pago, FormatTypes.decimals, 2),
                provisao_IR_IOF: helperFormat(classe.subtotal.provisao_IR_IOF, FormatTypes.decimals, 2),
                sli_fim: helperFormat(classe.subtotal.sli_fim, FormatTypes.decimals, 2),
                percent_sli: helperFormat(auxFormatPercent(classe.subtotal.percent_sli), FormatTypes.decimals, 2),
                colorIndex: index,
                // bgColor: theme.chartLightColors[index % theme.chartLightColors.length],
                bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLight),
                color: theme.fontColor,
                bold: true,
                openModal: null,
            });
    });
    if (dados_ativos_agrupados)
        rowsDadosAgrupados === null || rowsDadosAgrupados === void 0 ? void 0 : rowsDadosAgrupados.push({
            nome_ativo: 'Total',
            bgColor: '#444444',
            color: theme.backgroundColor,
            bold: true,
            sbr_ini: helperFormat(totalAtivos.sbr_ini, FormatTypes.decimals, 2),
            apl: helperFormat(totalAtivos.apl, FormatTypes.decimals, 2),
            res: helperFormat(totalAtivos.res, FormatTypes.decimals, 2),
            evento: helperFormat(totalAtivos.evento, FormatTypes.decimals, 2),
            sbr_fim: helperFormat(totalAtivos.sbr_fim, FormatTypes.decimals, 2),
            rendimento: helperFormat(totalAtivos.rendimento, FormatTypes.decimals, 2),
            imposto_pago: helperFormat(totalAtivos.imposto_pago, FormatTypes.decimals, 2),
            provisao_IR_IOF: helperFormat(totalAtivos.provisao_IR_IOF, FormatTypes.decimals, 2),
            sli_fim: helperFormat(totalAtivos.sli_fim, FormatTypes.decimals, 2),
            percent_sli: helperFormat(100, FormatTypes.decimals, 2),
            colorIndex: null,
        });
    return rowsDadosAgrupados;
}
export function formatRowsHistorico(dadosModal, loadingModal) {
    const rowsHistorico = dadosModal && !loadingModal
        ? dadosModal.slice(1).map((row) => {
            let i = 0;
            const dataAux = row[i++];
            return {
                data: dataAux.split('-').reverse().join('/'),
                operacao: row[i++],
                quant: helperFormat(row[i++], FormatTypes.truncate),
                preco: helperFormat(row[i++], FormatTypes.truncate),
                valor: helperFormat(row[i++], FormatTypes.decimals, 2),
                quantTotal: helperFormat(row[i++], FormatTypes.truncate),
                saldo: helperFormat(row[i++], FormatTypes.decimals, 2),
            };
        })
        : [];
    return rowsHistorico;
}
export function getColumnsHistorico() {
    const columnsHistorico = [
        {
            id: 'data',
            label: 'Data',
            freeze: true,
            align: AlignTypes.left,
        },
        {
            id: 'operacao',
            label: 'Operação',
            align: AlignTypes.left,
        },
        {
            id: 'quant',
            label: 'Quantidade',
            align: AlignTypes.right,
        },
        {
            id: 'preco',
            label: 'Preço do Ativo',
            align: AlignTypes.right,
        },
        {
            id: 'valor',
            label: 'Valor Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'quantTotal',
            label: 'Quantidade Total',
            align: AlignTypes.right,
        },
        {
            id: 'saldo',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
    ];
    return columnsHistorico;
}
